import { render, staticRenderFns } from "./CodeAnalyzer.vue?vue&type=template&id=2cf7e668"
import script from "./CodeAnalyzer.vue?vue&type=script&lang=js"
export * from "./CodeAnalyzer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports